import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import toast from "react-hot-toast";
import { authApiService } from "../../../../api/api";
import { IBatchCreateDto } from "../../../../types/batch.type";
import { IProduct } from "../../../../types/product.type";
import { ISelectsInput } from "../../../../types/selects.type";
import SelectChangeListInput from "../../../inputs/SelectChangeListInput/SelectChangeListInput";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import EditInput from "../inputs/EditInput/EditInput";
import ViewInput from "../inputs/ViewInput/ViewInput";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  warehouse: IProduct[];
}

const AddWarehouseForm: React.FC<Props> = (props) => {
  const [resourceSelect, setResourceSelect] = useState<ISelectsInput | null>();
  const [count, setCount] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [date, setDate] = useState<Date | null>(new Date());
  const [price, setPrice] = useState<string>("");

  const onApply = async () => {
    // const body: IWarehouseCreateDto[] = [];
    try {
      if (resourceSelect?.id && date && name && price) {
        const body: IBatchCreateDto = {
          batchName: name,
          batchDate: date,
          batchPrice: Number(price),
          batchQuantity: Number(count),
          product: {
            id: resourceSelect.id,
          },
        };

        const response = await authApiService.createBatch(body);

        if (response) {
          props.onApply();
        }
      } else {
        toast.error("All fields is Required");
      }
    } catch (err: any) {
      toast.error(err.message);
      console.error(err);
    }

    // props.onApply(body);
  };

  const onCountChange = (value: string, callback: any) => {
    if (isNaN(Number(value))) {
      toast.error(`Поле очікує числове значення.
        Наприклад: ${(Math.random() * 100).toFixed(2)}`);
      return;
    }
    callback(value);
  };

  return (
    <div className={styles.container}>
      <form className={styles.form}>
        <SelectChangeListInput
          items={props.warehouse.map((item) => ({
            name: item.name,
            id: item.id,
            subName: item.brand.name,
            secondSubName: item.capacity,
          }))}
          title="Products"
          value={resourceSelect}
          onClickActive={(value) => setResourceSelect(null)}
          onClickInactive={(value) => setResourceSelect(value)}
        />
        <ViewInput
          title="Product"
          value={resourceSelect ? resourceSelect.name : ""}
        />
        <EditInput
          value={name}
          setValue={(value) => setName(value)}
          isRequired
          title="Name of batcher"
        />
        <div className={styles.countContainer}>
          <EditInput
            value={count}
            setValue={(value) => onCountChange(value, setCount)}
            isRequired
            title="Count"
          />
          <EditInput
            value={price}
            setValue={(value) => onCountChange(value, setPrice)}
            isRequired={false}
            title="Price of batcher"
          />
          <div>
            <DatePicker
              selected={date}
              onChange={(value) => setDate(value)}
              className={styles.dateInput}
              onFocus={(e) => e.target.blur()}
            />
          </div>
        </div>
      </form>
      <ModalBottomButtons
        onPressBack={props.onClose}
        onPressApply={onApply}
        backTitle="Назад"
        applyTitle="Додати на склад"
      />
    </div>
  );
};

export default AddWarehouseForm;
